import React, { useEffect, useRef, useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHZonaGet } from "services/services-mia/RNHZonaGet";
import wellknown from "wellknown";
import { RNHZonaUpd } from "services/services-mia/RNHZonaUpd";

const wktPolygonSchema = yup.string()
    .required("Debe ingresar las coordenadas WKT")
    .test('valid-wkt-format', 'Formato de coordenadas inválido', function(value) {
        if (!value || !value.trim()) {
            return this.createError({ message: 'Ingrese las coordenadas' });
        }
        const wktString = `POLYGON((${value.trim()}))`;
        const parsed = wellknown.parse(wktString);
        if (!parsed) {
            return this.createError({ 
                message: 'El formato de las coordenadas no es válido'
            });
        }
        if (parsed.type !== 'Polygon') {
            return this.createError({ 
                message: 'Las coordenadas no forman un polígono válido'
            });
        }
        const coords = parsed.coordinates[0];
        if (coords.length < 4) {
            return this.createError({ 
                message: `Se requieren mínimo 4 coordenadas. Tienes ${coords.length - 1}.`
            });
        }
        return true;
    });

export default function UpdateModal({ updateList, user, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [inRequest, setInRequest] = useState(false);

    const getZonaData = async () => {
        setIsLoading(true);
        const result = await RNHZonaGet(credentials, { rnhZonaId: user.id })
        formikRef.current.setValues({
            id: result[0].rnhZonaId,
            nombre: result[0].rnhZonaNombre,
            cod: result[0].rnhZonaCod,
            wkt: result[0].rnhZonaWKT,
        });
        setData(result[0]);
        setIsLoading(false);
    }
    const handleSubmit = async (values) => {
        const response = await RNHZonaUpd(credentials, {
            id: data.rnhZonaId,
            name: values.nombre,
            cod: values.cod,
            wkt: values.wkt,
            version: data.rnhZonaVersion,
        })
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Zona modificada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    };
    useEffect(() => {
        getZonaData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: "",
                wkt: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(20, "Debe tener menos de 20 caracteres").required("Debe ingresar un código"),
                    wkt: wktPolygonSchema,
                })
            }
            onSubmit={(values) => {
                handleSubmit(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="nombre"
                        placeholder=""
                        labelText="Nombre de zona"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="cod"
                        placeholder=""
                        labelText="Código de zona"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="wkt"
                        placeholder="-58.362014 -34.618235, -58.361456 -34.621254, ..."
                        labelText="wkt"
                        multiline
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Modificar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
